import React from "react";
import { MulticolorCode } from "../../utils/colorTypes";
import { createMultiColorCircle } from "../../utils/utils";
import { __t } from "../../utils/translate";

type ColorButtonProps = {
  className?: string;
  id: string;
  color: string | MulticolorCode[];
  isSelected?: boolean;
  onClick: () => void;
};

const ColorButton: React.FC<ColorButtonProps> = ({
  id,
  color,
  isSelected = false,
  className = "",
  onClick,
}) => {
  const circleColors =
    typeof color === "array" ? color.map((c) => c.multicolor_code) : [color];

  const svgString =
    typeof window !== "undefined"
      ? createMultiColorCircle({
        x: 10,
        y: 10,
        radius: 10,
        colors: circleColors,
      })
      : null;

  return (
    <div className={`${className}`}>
      <input
        className="absolute h-0 w-0"
        type="radio"
        name={`color-${id}`}
        id={id}
        onClick={onClick}
      />
      <label
        // prettier-ignore
        className={`${isSelected ? "rounded-full outline-1 outline-offset-1 border border-gray group-hover:border-[#42463E] p-[2px]" : "rounded-full"} block
        ${(id.includes("weiß") || (id.includes("white"))) ? "border border-[#B7B7B1]" : " "}
        hover:cursor-pointer`}
        htmlFor={id}
      >
        {circleColors.length > 1 && !!svgString ? (
          <div
            className="h-[20px] w-[20px]"
            aria-label={`title-${id}`}
            dangerouslySetInnerHTML={{ __html: svgString || "" }}
          ></div>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-labelledby={`title-${id}`}
            role="img"
          >
            <title id={`title-${id}`}>{__t("Color")}</title>
            <circle cx="10" cy="10" r="10" fill={circleColors[0]} />
          </svg>
        )}
      </label>
    </div>
  );
};

export default ColorButton;
